import { Expose } from "class-transformer";
import { IsNumber, IsString } from "class-validator";

export class SettlementData {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  sendDate!: string;
  @IsString()
  @Expose()
  request!: string;
}
